module.exports = __webpack_public_path__ + "img/insert-04-gauche.aa254b96.svg";